import functions from "./functions.js";
// import tplListItem from "./tpl-list-item.js";
import pagination from "./pagination.js";
import lozad from 'lozad';


const list = {
    // references
    $form: null,
    form: null,
    $isHome: null,
    $list: null,
    list: null,
    $listItems: null,
    $listNoResults: null,
    $loader: null,
    $pagination: null,
    currPage: null,
    objectGroupId: null,
    $filtersCount: null,
    // form params
    params: {
        pets: '',
    },
    // params from shortcode and starting ones
    defaults: {
        dateFrom: '',
        dateTo: '',
        guests: '2,0',
        persons: 2,
        destination: '',
        //trip: '',
        type: '',
        sortBy: 0,
        _page: 1,
        perPage: 12,
        tagCategoryId: '',
        duration: '',
        language: 'en',

        objectName: '',
        tagCategoryId: '',
        rooms: '',
        beds: '',
        distanceBeach: '',
        seaView: '',
        pool: '',
        disabledPersons: '',
        parking: '',
        pets: '',
        ac: '',
        grill: '',
        washingMachine: '',
        sattv: '',
    },
    hiddenParams: ['catalogueid', 'language', 'perPage', 'tagCategoryId'],
    mainFields: ['dateFrom', 'dateTo', 'destination', 'trip', 'objectTypeId', 'guests', 'persons', 'personsInObject', 'sortBy', '_page', 'perPage', 'language'],
    // set by hash change to prevent change event on form fields
    pauseChange: false,
    // hashchange and form fields change are delayed
    changeTimeout: null,
    loading: false,
    // ajax load id
    loadId: 0,
    total: null,
    // for non ajax form to reset page on normal submit
    paginated: true,
    disabledFields: {},
    $showingTotal: null,
    $showingFrom: null,
    $showingTo: null,
    init() {
        list.$form = $('.search-form');
        list.form = list.$form[0];
        // list.advanced = list.$form.hasClass('form-advanced');

        if (!list.form) {
            return;
        }
        list.$isHome = $('body.home')[0];

        if (list.$isHome){
            $('.filter-dropdown').addClass('d-none');
        }

        $(document).on('click', '.filter-dropdown .dropdown-menu', e => {
            e.stopPropagation();
        });

        list.currPage = location.href;

        list.getDefaults();
        list.setDisabledFields();
        list.getParams();

        $('.select-trip').on('change', e => {
            list.params.trip = $(e.target).val();
        });

        list.objectGroupId = list.$form.attr('data-objectgroupid');
        if (list.objectGroupId == 1) {
            list.setRangeDates();
        }
        
        const $datePicker = $(list.$form.find('.datepicker-range')[1]);
        if (list.params.dateFrom && list.params.dateTo) {
            $datePicker.val(list.params.dateFrom + ' - ' + list.params.dateTo);
        }

        functions.setFormData(list.form, list.params);
        list.find();

        let prevTrip = list.params.trip;

        // register form submit
        list.$form.on('submit', e => {
            e.preventDefault();

            const objectGroupId = $(e.target).attr('data-objectgroupid');

            if (objectGroupId == 6) {

                list.hiddenParams.push('objectTypeId');

                functions.setUrlData(list.prepareUrlData(), true);
                list.getParams();

                if (list.$isHome && !list.params.trip) {
                    location = $(e.target).attr('action') + '#' + $.param(functions.cleanParams(list.prepareUrlData($(e.target))));
                } else if (list.params.trip && !prevTrip || (list.params.trip != prevTrip)) {
                    if (!list.params.trip && location != substr('#', $(e.target).attr('action'))[0]) {
                        location = $(e.target).attr('action') + $.param(functions.cleanParams(list.prepareUrlData()));
                    } else {
                        location = list.params.trip + '#' + $.param(functions.cleanParams(list.prepareUrlData()));
                    }
                } else {
                    list.currPage = list.currPage.split('#')[0];
                    location = list.currPage + '#' + $.param(functions.cleanParams(list.prepareUrlData()));

                    list.pauseChange = true;
                    clearTimeout(list.changeTimeout);
                    list.changeTimeout = setTimeout(() => {
                        list.find();
                        list.pauseChange = false;
                    }, 100);
                }

                prevTrip = list.params.trip;


            } else if (objectGroupId == 1) {

                if (list.$isHome) {
                    const page = functions.getLang() == 'hr' ? 'smjestaj' : 'accommodation';
                    location = list.currPage + page + '#' + $.param(functions.cleanParams(list.prepareUrlData()));
                } else {
                    functions.setUrlData(functions.cleanParams(list.prepareUrlData()), true);
                    list.getParams();
    
                    list.setRangeDates();
    
                    list.currPage = list.currPage.split('#')[0];
                    //console.log($.param(list.prepareUrlData()));
                    location = list.currPage + '#' + $.param(functions.cleanParams(list.prepareUrlData()));
    
                    list.pauseChange = true;
                    clearTimeout(list.changeTimeout);
                    list.changeTimeout = setTimeout(() => {
                        list.find();
                        list.pauseChange = false;
                    }, 100);
                }
                
            }
            
        });

        // Accommodation extra filter
        list.$filtersCount = $('.filters-count');

        $('.clear-filters').on('click', e => {
            let changed = false;
            let formData = {}
            $.map(list.params, (value, key) => {
                if (list.mainFields.indexOf(key) === -1) {
                    if (list.params[key] && list.params[key] != list.defaults[key]) {
                        changed = true;
                    }
                    formData[key] = list.defaults[key];
                }
            });
            functions.setFormData(list.form, formData);
            //list.toggleFilters(false);
            if (changed) {
                if (!e.target.classList.contains('clear-filters-mobile')) {
                    list.onChange();
                }
                if (!$('body.home')[0]) {
                    list.$form.submit();
                }
            }
        });

        // register form reset
        /*list.$form.find('.form-reset').on('click', e => {
            functions.setFormData(list.form, list.defaults);
        });*/

        // register paginate        
        $(document).on('click', '.list-pagination button[data-page]', e => {
            e.preventDefault();
            list.paginate(+$(e.currentTarget).attr('data-page'));
        });

        $('.sort-by').on('select2:select', () => {
            list.getParams();
            functions.setUrlData(list.prepareUrlData(), true);
            list.pauseChange = true;
            clearTimeout(list.changeTimeout);
            list.changeTimeout = setTimeout(() => {
                list.find();
                list.pauseChange = false;
            }, 100);
        });

        // register hashchange which trigger find
        /*$(window).on('hashchange', () => {
            list.pauseChange = true;
            clearTimeout(list.changeTimeout);
            list.changeTimeout = setTimeout(() => {
                list.getParams();
                if (list.params.dateFrom) {
                    functions.setFormData(list.form, list.params);
                }
                list.find();
                list.pauseChange = false;
            }, 100);
        });*/

    },
    getDefaults() {
        let defaults = $('.list-params').attr('data-params');
        defaults = defaults ? JSON.parse(defaults) : {};
        list.defaults = $.extend({}, list.defaults, defaults);
    },
    // get URL params and merge with defaults - (ex. things changed after init search)
    getParams() {
        list.params = $.extend({}, list.defaults, functions.getUrlData(true));
        if(list.objectGroupId == 1 && !list.$isHome) {
            //list.setFiltersCount();
        }
    },
    getFormData($form) {
        let formData = $.extend(functions.getFormData($form || list.$form), { _page: list.paginated ? list.params._page : 1 });
        list.paginated = true;
        // do not send same values as defaults
        $.map(formData, (val, key) => {
            if (list.defaults[key] == val) {
                delete formData[key];
            }
        });

        return formData;
    },
    prepareUrlData($form) {
        let o = {};
        $.map(list.getFormData($form), (val, key) => {
            if (list.hiddenParams.indexOf(key) == -1) {
                o[key] = val;
            }
        });
        return o;
    },
    setDisabledFields() {
        $.map((list.defaults.disabledFields || '').split(','), (name) => {
            if (list.form[name]) {
                list.disabledFields[name] = true;
                list.form[name].disabled = true;

                // needed for popover because it's a complex component with a hidden field and a button
                if (name == 'dateFrom' && $('input[name=dateFrom][type=hidden]')) {
                    $('.input-popover').attr('disabled', 'disabled');
                }
            }
        });
    },
    setLoadingMode($form) {
        if (!list.loading) {
            list.loading = true;
            // form submit btn
            ($form || list.$form)
                .find('.form-submit').prop('disabled', true)
                .find('.spinner-border').removeClass('d-none');

            list.$list.addClass('loading');
            list.loadId && functions.scrollToElement(list.$list, 100);
        }
    },
    unsetLoadingMode() {
        if (list.loading) {
            list.loading = false;
            list.$form
                .find('.form-submit').prop('disabled', false)
                .find('.spinner-border').addClass('d-none');
            list.$list.removeClass('loading');
            list.loadId > 1 && functions.scrollToElement(list.$list, 100);
        }
    },
    find() {
        // init list
        if (!list.$list) {
            list.$list = $('.list-params');
            list.list = list.$list[0];
            list.$listItems = list.$list.find('.list-items');
            list.$listNoResults = list.$list.find('.list-no-results').removeClass('d-none').remove();
            list.$loader = list.$list.find('.list-loader');
            list.$pagination = $('<div class="list-pagination container text-center">').appendTo(list.list);
            list.$showingFrom = $('.items-total-wrapper .showingFrom');
            list.$showingTo = $('.items-total-wrapper .showingTo');
            list.$showingTotal = $('.items-total-wrapper .showingTotal');
        }

        list.setLoadingMode();


        let ajaxId = ++list.loadId;

        $.get('/services/list.php', list.params).then(response => {
            if (ajaxId !== list.loadId) {
                return;
            }
            response = JSON.parse(response);
            list.total = response.total;
            list.$listItems.html(response.html);
            list.$pagination.html(pagination({
                currentPage: list.params._page,
                total: list.total,
                perPage: list.defaults.perPage,
            }));

            if (list.total != 0) {

                const $cardImgTopSlider = $('.card-img-top-slider');
                $cardImgTopSlider.lightSlider({
                    item: 1,
                    controls: true,
                    mode: 'fade',
                    slideMargin: 0,
                    pauseOnHover: false,
                    auto: false,
                    enableDrag: false,
                    pager: false,
                    loop: true,
                });

                window.observer.observe();

                if (list.total <= list.params._page * list.defaults.perPage && list.total >= (list.params._page - 1) * list.defaults.perPage) {
                    list.$showingTo.text(list.total);
                } else {
                    list.$showingTo.text(list.params._page * list.defaults.perPage);
                }
                list.$showingTotal.text(list.total);
                list.$showingFrom.text(list.params._page * list.defaults.perPage - (list.defaults.perPage - 1));
            } else {
                $('.list .items-total-wrapper, .list .list-pagination').addClass('d-none');
                $('.items-total-wrapper').addClass('d-none');
            }

            // observer.observe();
            list.unsetLoadingMode();

            list.onUnitClick();
            
        });

    },
    onUnitClick() {
        $('.card-unit-item').on('click', e => {
            const $unitItem = $(e.target).parents('tr');
            const unitId = $unitItem.attr('data-unitid');
            //const url = $unitItem.attr('unit-item-url') + '#' + $.param(list.prepareUrlData()) + '&dateTo=' + list.params.dateTo + '&unitItem=#unit-' + unitId;
            const url = $unitItem.attr('unit-item-url') + '&unitItem=#unit-' + unitId;
            location = url;
        });
    },
    paginate(page) {
        if (page != list.params._page) {
            list.paginated = true;
            list.params._page = page;
        }
        //console.log(list.prepareUrlData())
        functions.setUrlData(list.prepareUrlData(), true);
        list.pauseChange = true;
        clearTimeout(list.changeTimeout);
        list.changeTimeout = setTimeout(() => {
            list.find();
            list.pauseChange = false;
        }, 100);
    },
    setFiltersCount() {
        let filtersCount = 0;
        $.map(list.params, (val, name) => {
            list.mainFields.indexOf(name) === -1 && (val !== list.defaults[name]) && (filtersCount++);
        });
        list.$filtersCount.html(filtersCount || '');
    },
    // on form fields change set URL which will trigger load mode
    onChange() {
        if (!list.$isHome) {
            return;
        }
        clearTimeout(list.changeTimeout);
        if (list.pauseChange) {
            return;
        }
        list.changeTimeout = setTimeout(() => {
            functions.setUrlData(list.getFormData(), list.$isHome);
        }, 300);
    },
    setRangeDates() {
        if (list.params.dateFrom.includes(' - ')) {
            list.params.dateTo = list.params.dateFrom.split(' - ')[1];
            list.params.dateFrom = list.params.dateFrom.split(' - ')[0];
        }
    },
};

$(() => {
    list.init();
});